import { globalStyleSheet } from "@/assets/css/global";
import '@/components/reusable/RPlaylistCover';
import { player } from "@/utils/player";
import { eventEmitter } from "@/utils/eventEmitter";
import '@/components/reusable/RProgressBar';
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
    :host {
        display: flex;
        width: 100%;
    }
    
    r-progress-bar {
        width: 100%;
    }
`);
export class RPlayerProgressBar extends HTMLElement {
    value;
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [globalStyleSheet, styleSheet];
    }
    connectedCallback() {
        this.#abortController = new AbortController();
        this.#initDOM();
        this.#updateProgressBar();
        if (player.playing) {
            this.#startUpdatingProgressBar();
        }
        this.#processBarEvents();
        this.#processSongPlay();
        this.#processSongPause();
        this.#processSongStop();
        this.#processNext();
        this.#processPrevious();
        this.#processTrackChange();
        this.#processCurrentTimeChange();
    }
    disconnectedCallback() {
        this.#abortController.abort();
        this.#eventEmitterIds.forEach(({ title, id }) => {
            eventEmitter.remove(title, id);
        });
        this.#eventEmitterIds.clear();
        /**
         * TODO костыль потому что событие stop на эмитере не отрабатыватет и
         * поэтому ошибка при апдейте прогресс бара так как он не останавливается
         * */
        this.#stopUpdatingProgressBar();
    }
    #abortController;
    #eventEmitterIds = new Set();
    /** @type {number | null} */
    #intervalId = null;
    #updateProgressBar = () => {
        const totalSeconds = player.currentTrack.duration / 1000;
        this.#barEl.elapsed = player.currentTime / totalSeconds * 100;
    };
    /** @returns {RProgressBar} */
    get #barEl() {
        return this.shadowRoot.querySelector('r-progress-bar');
    }
    #createProgressBarEl() {
        const el = /** @type {RProgressBar} */ document.createElement('r-progress-bar');
        this.shadowRoot.append(el);
    }
    #initDOM() {
        this.#createProgressBarEl();
    }
    #processBarEvents() {
        const cb = () => {
            this.#stopUpdatingProgressBar();
            this.#startUpdatingProgressBar();
        };
        this.#barEl.addEventListener('current-time-change', e => {
            player.removeEventListener('playing', cb);
            player.currentTime = Math.round(e.detail.elapsed / 100 * player.duration / 1000);
            /** Ждём дозагрузки данных, а только затем после начала проигрывания продолжаем обновлять прогресс-бар. */
            this.#stopUpdatingProgressBar();
            player.addEventListener('playing', cb, { once: true });
        }, { signal: this.#abortController.signal });
        this.#barEl.addEventListener('drag start', () => {
            this.#stopUpdatingProgressBar();
        }, { signal: this.#abortController.signal });
    }
    #processCurrentTimeChange() {
        const title = 'current time change';
        const { id } = eventEmitter.on(title, () => {
            this.#updateProgressBar();
        });
        this.#eventEmitterIds.add({ title, id });
    }
    #processNext() {
        const title = 'next';
        const { id } = eventEmitter.on(title, () => {
            this.#barEl.elapsed = 0;
        });
        this.#eventEmitterIds.add({ title, id });
    }
    #processPrevious() {
        const title = 'previous';
        const { id } = eventEmitter.on(title, () => {
            this.#barEl.elapsed = 0;
        });
        this.#eventEmitterIds.add({ id, title });
    }
    #processSongPause() {
        const title = 'pause';
        const { id } = eventEmitter.on(title, () => {
            this.#stopUpdatingProgressBar();
            this.#updateProgressBar();
        });
        this.#eventEmitterIds.add({ id, title });
    }
    #processSongPlay() {
        player.addEventListener('playing', () => {
            this.#updateProgressBar();
            this.#startUpdatingProgressBar();
        }, { signal: this.#abortController.signal });
    }
    #processSongStop() {
        const title = 'stop';
        const { id } = eventEmitter.on(title, () => {
            this.#stopUpdatingProgressBar();
            this.#updateProgressBar();
        });
        this.#eventEmitterIds.add({ id, title });
    }
    #processTrackChange() {
        const title = 'current track change';
        const { id } = eventEmitter.on(title, () => {
            this.#updateProgressBar();
            if (!player.playing) {
                this.#stopUpdatingProgressBar();
            }
        });
        this.#eventEmitterIds.add({ title, id });
    }
    #startUpdatingProgressBar() {
        this.#intervalId = setInterval(this.#updateProgressBar, 500);
    }
    #stopUpdatingProgressBar() {
        clearInterval(this.#intervalId);
        console.log('stop');
        this.#intervalId = null;
    }
}
customElements.define('r-player-progress-bar', RPlayerProgressBar);
